<template>
  <div class="bottom_btn">
    <div class="clearfix">
      <img
        :src="allSelect ? selectImg : unSelectImg"
        alt=""
        class="left choose_img"
        @click="isCheckedleAll"
      />
      <div class="font12 font_weight400 colo087 check_all left">全选</div>
      <div v-if="!showDeleteAll">
        <div
          class="font14 font_weight500 colof right result_all"
          @click="goPurCheckOut"
        >
          结算（{{ getCartList.seleteNum }}）
        </div>
        <div class="right text_right price_all">
          <div class="font12 font_weight400 colo055 line_height_17">
            合计（不含税）：<span class="colof00 line_height_14 total_font">{{
              getCartList.price | currency(false)
            }}</span>
          </div>
          <div class="font10 font_weight400 colo055 line_height_14 item_all">
            <span class="item_mr"
              >商品税费：<span class="colof00 line_height_12 item_font">{{
                getCartList.tax | currency(false)
              }}</span></span
            >
            <!-- <span>已优惠：<span class="colof00 line_height_12 item_font">{{getCartList.price | currency(false)}}</span></span> -->
          </div>
        </div>
      </div>
      <div
        v-if="showDeleteAll"
        class="right font14 font_weight500 colof right delete_all"
        @click="deleteCart"
      >
        删除商品
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    showDeleteAll: {
      type: Boolean,
      default: false
    },
    allSelect: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectImg: require("@/assets/login/select@2x.png"),
      unSelectImg: require("@/assets/login/unselect_icon@2x.png")
      // allSelect: false
    };
  },
  computed: {
    getCartList() {
      return this.$store.getters.getCartList;
    }
  },
  methods: {
    isCheckedleAll() {
      this.$emit("isCheckedleAll");
    },
    deleteCart() {
      this.$emit("deleteCart");
    },
    goPurCheckOut() {
      this.$emit("goPurCheckOut");
    }
  }
};
</script>

<style lang="less" scoped>
.bottom_btn {
  z-index: 99;
  background: #fff;
  box-shadow: 0px -3px 6px -3px rgba(193, 200, 207, 0.5);
  position: fixed;
  bottom: 49px;
  left: 0;
  right: 0;
  height: 60px;
  .choose_img {
    width: 18px;
    height: 18px;
    margin: 21px 4px 0 12px;
  }
  .check_all {
    margin-top: 22px;
  }
  .result_all {
    background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
    border-radius: 2px 0px 0px 2px;
    padding: 20px 10px 20px 24px;
  }
  .price_all {
    margin: 11px 4px 0 0;
    max-width: 200px;
    .item_mr {
      margin-right: 5px;
    }
    .item_all {
      margin-top: 4px;
    }
    .total_font {
      margin-top: 2px;
    }
    .item_font {
      margin-top: 1px;
    }
  }
  .delete_all {
    background: linear-gradient(90deg, #ff7676 0%, #ff0000 100%);
    border-radius: 2px 0px 0px 2px;
    padding: 20px 21px;
  }
}
</style>
